import type { RecentVisit } from "../recent-visits-store";

export function normalizePath(path: string): string {
  const trimmed = path.replace(/\/+$/, "");

  return trimmed === "" ? "/" : trimmed;
}

export function dedupeByPath(visits: RecentVisit[]): RecentVisit[] {
  const seenPaths = new Set<string>();

  return visits.filter((visit) => {
    if (seenPaths.has(visit.path)) return false;

    seenPaths.add(visit.path);

    return true;
  });
}
